var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChiken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 37.4961L13.683 46.1131C15.6897 47.5432 15.96 50.5505 14.2023 52.3081C12.6131 53.8974 10.0364 53.8974 8.44714 52.3081C7.19421 51.0552 6.76532 49.0248 7.48794 47.5121C5.97525 48.2348 3.94487 47.8059 2.69194 46.5529C1.10269 44.9637 1.10269 42.387 2.69194 40.7977C4.44963 39.04 7.45682 39.3104 8.88695 41.3171L17.504 32.7001",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8958 5.87305C34.9652 -0.196358 43.5404 0.286313 49.1272 5.87305C53.5858 10.3317 54.7935 16.6938 52.0143 22.1664C47.3987 16.048 37.0106 20.7357 38.9545 28.4255C34.6689 26.6413 30.9908 32.1506 33.9428 35.4644C27.7555 37.9828 21.5994 39.0393 18.7802 36.2201C13.1934 30.6333 22.8264 11.9424 28.8958 5.87305Z",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChiken);
export default __webpack_public_path__ + "static/media/ic_chiken.397a29cb1f7b40ad360bb1d68ee107cc.svg";
export { ForwardRef as ReactComponent };